/**
 * このゲームの識別子。**Phaser を引かない軽いモジュール**にしておく
 * （`registry.ts` と `platform/` から参照されるので、ここが重いと初期バンドルが太る）。
 *
 * 🔴 **この文字列は後から変更できない**。D1 の `game_key` / `src/games/<key>/` /
 *   `src/locales/<lang>/<key>.json` / `public/assets/<key>/` / localStorage の `<key>.*`
 *   が全部これと同じでなければならない（CLAUDE.md の規則1）。
 *
 * 🔴 **「ピクロス」は任天堂の登録商標**なので使わない（GAMES-ROADMAP の 🔴）。
 *   一般名の `nonogram` を採る。画面に出す日本語名は「ノノグラム」。
 */
export const GAME_KEY = 'nonogram';
